import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

export const AuthWrapper = ({ children }) => {
  const qalortUser = useSelector((state) => state.user.userData);
  const navigate = useNavigate();

  useEffect(() => {
    const returnUrl = `${window.location.pathname}${window.location.search}`;
    !qalortUser && navigate(`/login?returnUrl=${returnUrl}`);
  }, []);

  return qalortUser && children;
};
